module.exports = __webpack_public_path__ + "img/5794af5.svg";